/* eslint-disable no-multi-spaces */
export const HAS_FEE_APP_MODULES = [
  {
    app_id: 1,
    module_id: 1,
  },
  {
    app_id: 1,
    module_id: 5,
  },
  {
    app_id: 3,
    module_id: 2,
  },
  {
    app_id: 3,
    module_id: 4,
  },
  {
    app_id: 3,
    module_id: 5,
  },
  {
    app_id: 3,
    module_id: 6,
  },
  {
    app_id: 3,
    module_id: 7,
  },
  {
    app_id: 3,
    module_id: 8,
  },
]

/*
 * filter date type
 **/
export const FILTER_DATE_TYPE = Object.freeze({
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
})

/*
 * download ext
 **/
export const DOWNLOAD_EXT_TEXT = Object.freeze({
  EXCEL: 'message.excel',
  CSV: 'message.csv',
})

export const DOWNLOAD_EXT_VALUE = Object.freeze({
  EXCEL: 'excel',
  CSV: 'csv',
})

export const DOWNLOAD_EXTS = Object.freeze(
  [
    ...Object.keys(DOWNLOAD_EXT_TEXT).map((key) => ({
      text: DOWNLOAD_EXT_TEXT[key],
      value: DOWNLOAD_EXT_VALUE[key],
    })),
  ]
)

/*
 * report data type
 **/
export const REPORT_DATA_TYPE_TEXT = Object.freeze({
  TABLE: 'message.table',
  CHART_BAR: 'message.chartbar',
  CHART_LINE: 'message.chartline',
  CHART_PIE: 'message.chartpie',
})

export const REPORT_DATA_TYPE_ICON = Object.freeze({
  TABLE: '<i class="fas fa-table"></i>',
  CHART_BAR: '<i class="fas fa-chart-bar"></i>',
  CHART_LINE: '<i class="fas fa-chart-line"></i>',
  CHART_PIE: '<i class="fa fa-pie-chart"></i>',
})

export const REPORT_DATA_TYPE_VALUE = Object.freeze({
  TABLE: 'table',
  CHART_BAR: 'chart_bar',
  CHART_LINE: 'chart_line',
  CHART_PIE: 'chart_pie',
})

export const REPORT_DATA_TYPES = Object.freeze(
  [
    {
      icon: REPORT_DATA_TYPE_ICON.TABLE,
      text: REPORT_DATA_TYPE_TEXT.TABLE,
      value: REPORT_DATA_TYPE_VALUE.TABLE,
    },
    {
      icon: REPORT_DATA_TYPE_ICON.CHART_BAR,
      text: REPORT_DATA_TYPE_TEXT.CHART_BAR,
      value: REPORT_DATA_TYPE_VALUE.CHART_BAR,
    },
    {
      icon: REPORT_DATA_TYPE_ICON.CHART_LINE,
      text: REPORT_DATA_TYPE_TEXT.CHART_LINE,
      value: REPORT_DATA_TYPE_VALUE.CHART_LINE,
    },
  ]
)

export const GENDER = Object.freeze({
  MALE: 'm',
  FEMALE: 'f',
})

export const WAGE_TYPE = Object.freeze({
  DAILY: 'daily',
  MONTHLY: 'monthly',
})

export const PAYSLIP_CONDITION_TYPE = Object.freeze({
  BASIC: 'basic',
  ADVANCED: 'advanced',
})

export const PAYSLIP_CONDITION_TRANSLATE = Object.freeze({
  [PAYSLIP_CONDITION_TYPE.BASIC]: 'apps.payroll.message.conditiontypebasic',
  [PAYSLIP_CONDITION_TYPE.ADVANCED]: 'apps.payroll.message.conditiontypeadvanced',
})

export const PAYROLL_CONDITION_VARIABLE = Object.freeze({
  WAGES: 'wages',
  WORKING_HOURS: 'working_hours',
})

export const PAYROLL_CONDITION_VARIABLE_TRANSLATE = Object.freeze({
  [PAYROLL_CONDITION_VARIABLE.WAGES]: 'apps.payroll.message.variablewages',
  [PAYROLL_CONDITION_VARIABLE.WORKING_HOURS]: 'apps.payroll.message.variableworkinghours',
})

export const PAYROLL_CONDITION_OPERATOR = Object.freeze({
  GREATER_THAN: '>',
  EQUAL: '=',
  LESS_THAN: '<',
})

export const DOCUMENT_STATUS = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
})

export const DOCUMENT_RPOCESS_STATUS = Object.freeze({
  PENDING: 'pending',
  UNCOMPLETED: 'uncompleted',
  COMPLETED: 'completed',
  REJECTED: 'rejected',
})

export const USER_PERMISSION_TYPE = Object.freeze({
  GENERAL: 'general',
  RELATIONAL: 'relational',
})

export const BILLING_SERVICE_USAGE = {
  RECORD: 'RECORD',
  FILE: 'FILE',
  MESSAGE_LINE: 'MESSAGE_LINE',
  EMAIL: 'EMAIL',
  QRCODE: 'QRCODE',
  BRANCH: 'BRANCH',
  WAREHOUSE: 'WAREHOUSE',
  USER: 'USER',
}

HAS_FEE_APP_MODULES.map((item) => {
  const key = `APPID${item.app_id}_MODULEID${item.module_id}`
  BILLING_SERVICE_USAGE[key] = key
})

export const BILLING_PAYMENT_METHOD = Object.freeze({
  CARD: 'card',
  PROMPTPAY: 'promptpay',
  LINE_PAY: 'line_pay',
})

export const BILLING_INVOICE_STATUS = Object.freeze({
  PENDING: 'pending',
  PAID: 'paid',
})

export const COUNTRY_CODE = Object.freeze({
  TH: 'th',
})

export const TRANSACTION_TYPE = Object.freeze({
  BILL: 'bill',
  INVOICE: 'invoice',
})

export const POS_PAYMENT_METHOD = Object.freeze({
  CASH: 'cash',
  CARD: 'card',
  PROMPTPAY: 'promptpay',
})

export const TAX_FORM_TYPE = Object.freeze({
  TAX: 'tax',
  SERVICE_CHARGE: 'service_charge',
  FEE: 'fee',
})

export const FEE_CALC_TYPE = Object.freeze({
  NET: 'net',
  CUSTOM: 'custom',
})

export const FIREBASE_POS_CLIENT_REF = 'pos/shop_id-%s/branch_id-%s/ps_id-%s/client'
export const FIREBASE_POS_NOTIFY_REF = 'pos/shop_id-%s/branch_id-%s/ps_id-%s/notify'
export const FIREBASE_POS_ORDER_REF  = 'pos/shop_id-%s/branch_id-%s/ps_id-%s/order'
export const FIREBASE_POS_QUEUE_REF  = 'pos/shop_id-%s/branch_id-%s/ps_id-%s/queue'
export const FIREBASE_STOCK_REF      = 'pos/shop_id-%s/stock'

export const FIREBASE_ORDER_PLATFORM_TYPE = Object.freeze({
  MENU_ONLINE: 'menu_online',
  POS: 'pos',
})

export const FIREBASE_CLIENT_STATUS = Object.freeze({
  WAITING_FOR_APPROVE: 'waiting_for_approve',
  APPROVED: 'approved',
  REJECTED: 'rejected',
})

export const FIREBASE_NOTIFY_CODE = Object.freeze({
  REQUEST_APPROVE_ACCESS: 'request_approve_access',
  REQUEST_APPROVE_ORDERS: 'request_approve_orders',
  NEW_ORDERS_CREATED: 'new_orders_created',
  NEW_QUEUE_CREATED: 'new_queue_created',
  CALL_STAFF: 'call_staff',
  CALL_CHECKOUT: 'call_checkout',
})

export const FIREBASE_ORDER_STATUS = Object.freeze({
  WAITING_FOR_APPROVE: 'waiting_for_approve',
  APPROVED: 'approved',
  REJECTED: 'rejected',
})

export const FIREBASE_NOTIFY_RESPONSE_STATUS = Object.freeze({
  WAITING_FOR_APPROVE: 'waiting_for_approve',
  APPROVED: 'approved',
  REJECTED: 'rejected',
})



// WEBPACK FOOTER //
// ./src/helpers/enum.js